import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearSquares } from '../actions/';

class Trash extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <button
        onClick={this.props.clearSquares}
        className="btn btn-danger"
        title="Effacer le tracé en cours">
        <span className="glyphicon glyphicon-trash"></span>
      </button>
    );
  }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ clearSquares }, dispatch);
}

export default connect(null, mapDispatchToProps)(Trash)
